import { createAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "store/store";
import { SurveyAnswerDetail, SurveyAnswerQueryParams } from "../types";

export interface SurveyState {
	surveyList: SurveyAnswerDetail[];
	surveyTotal: number;
}

const initialState: SurveyState = {
	surveyList: [],
	surveyTotal: 0,
};

export const surveySlice = createSlice({
	name: "surveyAnswer",
	initialState,
	reducers: {
		setListSurveyAnswer(state, action) {
			state.surveyList = action.payload.data;
		},
		setTotalSurvey(state, action) {
			state.surveyTotal = action.payload.total;
		},
	},
});

export const { setListSurveyAnswer, setTotalSurvey } = surveySlice.actions;

export const selectSurveyList = (state: RootState) => state.surveyAnswer.surveyList;
export const selectSurveyTotal = (state: RootState) => state.surveyAnswer.surveyTotal;

export interface GetListSurveyAnswerPayload {
	query: SurveyAnswerQueryParams;
	callback?: () => void;
}

export const getListSurveyAnswerAsync = createAction(
	"surveyAnswer/getListSurveyAnswerAsync",
	(payload: GetListSurveyAnswerPayload) => ({
		payload,
	}),
);

export default surveySlice.reducer;
